import React from 'react'
import { SVGIconProps } from '../types'
const SvgSignalWifiStatusbar3Bar26X24Px = ({
  size = 16,
  ...props
}: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M8 1.846c4.468 0 7.446 2.437 7.742 2.659l-1.935 2.41.002.002-5.803 7.23-.006.007-.004-.007h-.002L2.19 6.918l.001-.001L.258 4.505C.554 4.283 3.532 1.846 8 1.846"
      />
    </g>
  </svg>
)
export default SvgSignalWifiStatusbar3Bar26X24Px
